import { Component, OnInit, Input } from '@angular/core';
import { Product } from 'src/app/models/models';

@Component({
  selector: 'order-product-name',
  templateUrl: './order-product-name.component.html',
  styleUrls: ['./order-product-name.component.scss']
})
export class OrderProductNameComponent implements OnInit {

  constructor() { }
  @Input() product:Product
  productDisplayName:string = "";
  sessionslotName :string="";
  ngOnInit() {
    if(this.product.isSessionProduct)
    {
     
      this.productDisplayName = this.product.productName.split("(")[0].trim(); //remove session slot name from product name
      this.sessionslotName = "(" + this.product.productName.split('(')[1].trim(); // get session slot name
    }
    else{
      this.productDisplayName = this.product.productName
    }
  }

}
